import type { FaireProductEntity } from "../../entity_types/product";

export const p_tsq3q62hw3: FaireProductEntity = {
  token: "p_tsq3q62hw3",
  type: "product",
  name: "Plus Size Elegant Shawl Bat-wing Sleeve Evening Dresses",
  brandToken: "b_9x9dfusr4t",
  brandName: "Ever-Pretty",
  imageUrl:
    "https://cdn.faire.com/fastly/bc1b4ac7ba8e09873bdd587880069abd6c41002c81e987cb359c9f77b23ba47c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf9e96305f7a5aff9f2c5eb194474ea6c6d510d7c36b8f4e87361c2b8b981708.jpeg",
    "https://cdn.faire.com/fastly/ed99814f37694f994e9557e30d70a6ae6945cba1f9d53b2b553f2b495bfbd5ea.jpeg",
    "https://cdn.faire.com/fastly/70340fb2ae6077318ce4782c3d5ac37bb0b35c659293ff2030ad760375e3a7b4.jpeg",
    "https://cdn.faire.com/fastly/10c60cb48e3b380b782cafe44cb83783cc42606dce1f198da2d2845cf1ccfae7.jpeg",
    "https://cdn.faire.com/fastly/ef71a7839f63a222c752dff3f734a9e9200031be82c08da708e0b9e005b3f107.jpeg",
    "https://cdn.faire.com/fastly/d5b67530fa338e57e0ce8cc9f3c21833a526d459f6cde1b1a9c74485579f287d.jpeg",
    "https://cdn.faire.com/fastly/3b63a46edfaa67da324a2215667486c8056e6b10a0b2743763c37ec056c068de.jpeg",
    "https://cdn.faire.com/fastly/74e5b42b60cb31c21de19f931aef20836e7bf13dff933f48fb98bfb0c768c759.jpeg",
    "https://cdn.faire.com/fastly/597c18ee4c39b20db270e8a2eb8ef51db2e61af5c83fec6f32c1a36effa301d9.jpeg",
    "https://cdn.faire.com/fastly/24db3464f37526f00bb34d6bdc304f681f03e10fce229f8b13b6e5d8557e2186.jpeg",
    "https://cdn.faire.com/fastly/d41bd6befe73b8777d1c515929483bbfe8a4039e5ad0865ea45b779642b4d33d.jpeg",
    "https://cdn.faire.com/fastly/75d2298e7fe82a5e6a3657025ebdcbbc59eab618bcc0fc8df76a68c374f8e8f6.jpeg",
    "https://cdn.faire.com/fastly/af90a616e225c720af0e61ce2bf8ed640fd691c3102cdc81ee83b870fe4c99b3.jpeg",
    "https://cdn.faire.com/fastly/07c73bcb0d52d934029976683bd42e70a572e427d6ab0b6b7144c36f785695b1.jpeg",
    "https://cdn.faire.com/fastly/8310a61b5549d953ab58054d849206e092ec8c1bc1baed7ece6be7f83ffd38f6.jpeg",
    "https://cdn.faire.com/fastly/0d24d0d0d02e9a9246d7b2352ad61aeff57ce0b3074dd4ab02fa7f8bc03d6f3b.jpeg",
    "https://cdn.faire.com/fastly/c11aaeee17f51854aa9ec86f20d3b56afdede43dc9d822aae6788ba5b9a54199.jpeg",
    "https://cdn.faire.com/fastly/0b46e56bfc59a5077926e27a333ad3fc0c557c9f013751b8d0db6884ad1de2cd.jpeg",
    "https://cdn.faire.com/fastly/e8493c0060ce0b3898a990ed146fc995973ecc311772f60bebcffb8079fb26b6.jpeg",
    "https://cdn.faire.com/fastly/b745c59992d3079c2a393765e8f9e7752a6b3f69aae8b69ba6bdbc5bdcff2143.jpeg",
  ],
  priceDollars: 45.99,
  description:
    "Make an entrance in this show-stopping chiffon maxi dress. The flowing batwing sleeves create an elegant shawl effect, while the waist applique defines your silhouette. Perfect for black-tie events, mother of the bride, or formal occasion. The airy chiffon fabric moves beautifully while keeping you comfortable all evening.\n\n• Fit: Please refer to size chart.\n• Length: Floor length.\n• Sleeve Style: Short sleeves.\n• Closure: It is concealed a zipper up the back.\n• Undergarments: It is not padded, with lining.\n• Fabric: The garment comprises chiffon.\n• Stretch: Fabric is no stretch.\n• Occasion: Wedding Guest, Formal Event, Evening Party, Cocktail Party, Church",
  tags: [],
  msrpDollars: 91.98,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:36.633Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
